export type TroubleshootingOption = "case_triage" | "ev_check" | "log_request";

export interface TroubleshootingConfig {
  label: string;
  description: string;
}

export const TROUBLESHOOTING_CONFIG: Record<TroubleshootingOption, TroubleshootingConfig> = {
  case_triage: {
    label: "Case Triage",
    description: "Clarify symptoms and form an initial hypothesis",
  },
  ev_check: {
    label: "EV Check",
    description: "Verify environment, versions, and configuration",
  },
  log_request: {
    label: "Log Request",
    description: "Specify traces and logs to collect from the customer",
  },
};

export const TROUBLESHOOTING_OPTIONS = Object.keys(
  TROUBLESHOOTING_CONFIG
) as TroubleshootingOption[];
